import React from 'react';
import GenericSearchForm from '../GenericSearch/GenericSearchForm';

const UsersSearchForm = (props) => {
  const fields = [
    {
      key: 'username',
      label: 'Username',
      placeholder: 'Username',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      key: 'email',
      label: 'Email',
      placeholder: 'Email',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      key: 'phone_number',
      label: 'Phone number',
      placeholder: 'Phone number',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: '', label: 'All' },
        { value: 'active', label: 'Active' },
        { value: 'blocked', label: 'Blocked' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      key: 'user_role',
      label: 'User Role',
      type: 'select',
      options: [
        { value: '', label: 'All' },
        { value: 'admin', label: 'Admin' },
        { value: 'restricted', label: 'Restricted' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    }
  ];

  return <GenericSearchForm {...props} fields={fields} />;
};

export default UsersSearchForm;